import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Google Fonts
const link = document.createElement('link');
link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=IBM+Plex+Mono:wght@300;400;500&family=DM+Sans:wght@300;400;500;600&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

// Reset global
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #070707; color: #F0EDE8; }
  ::-webkit-scrollbar { width: 3px; background: #070707; }
  ::-webkit-scrollbar-thumb { background: #2A2A2A; }
  input[type=number]::-webkit-inner-spin-button { -webkit-appearance: none; }
  select option { background: #111; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
